import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  Box,
  Paper,
  Chip,
  Divider,
  Tooltip,
} from "@mui/material";

import GroupIcon from "@mui/icons-material/Group";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import RotateLeftOutlinedIcon from "@mui/icons-material/RotateLeftOutlined";
import ArticleIcon from "@mui/icons-material/Article";
import HelpIcon from "@mui/icons-material/Help";
import { BASE_URL } from "./../../global";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import PaymentReport from "../dashboard/paymentReport";
import StdInOut from "../dashboard/stdInOut";
import Dashboard_background from "../image/client.jpg";
import { dashboardGuide } from "./guide";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ErrorModal from "../../utils/components/errorModal";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

import TodaysStdInOut from "./todaysStdInOut";
import EditWrap from "../commonComponent/editWrap";
import DucserialModal from "./ducserialModal";

const CustomCard = ({ icon, iconColor, title, count, link , ...rest }) => {
  const IconComponent = icon; // Dynamically set the icon component

  return (
    <Link to={link} style={{ textDecoration: "none" }}>
      <Card      
        className="cardContent"
        sx={{
          m: 2,
          p: 1,
          display: "flex",
          border: 1,
          borderColor: "#283593",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        style={{ height: "125px" }}
        onClick={()=>{
          if(link == "/master/masterEQP/count" || link == "/master/client/count" || link == "/inward/count" || link == "/certificate/today" || link == "/scheduler/count"){
            sessionStorage.setItem("searched", "true");
          }
        }}
        {...rest}
      >
        <IconComponent
          sx={{ color: iconColor || "#283593" }}
          style={{ fontSize: "80px" }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CardContent sx={{ flex: "1 0 auto" }}>
            <Typography sx={{fontSize:"15px", fontWeight:"600", color: iconColor }}>{title}</Typography>
            <Typography
              component="div"
              variant="h4"
              sx={{
                fontWeight: "bold",
                color: iconColor,
              }}
            >
              {count}
            </Typography>
          </CardContent>
        </Box>
      </Card>
    </Link>
  );
};

export default function Dashboard(props) {
  const dashboardGuides = dashboardGuide();
  const [clientCount, setClientCount] = React.useState("");
  const [certificateCount, setCertificateCount] = React.useState("");
  const [userType, setUserType] = React.useState(localStorage.getItem("type"));
  const [userId, setUserId] = React.useState(localStorage.getItem("id"));
  const [counts, setCounts] = useState({
    todaysClientsCount: 0,
    todaysSrfsCount: 0,
    todaysCertificatesCount: 0,
    todaysRenewalsCount: 0,
    overAllActiveIncCount: 0,
    overAllRenewalCount: 0,
    overAllClientDueCount: 0,
    todayClientDueCount: 0,
    masterRenewalCount: 0,
    selfJobs: 0,
    assignedJobs: 0,
    pendingJobs: 0,
    completedJobs: 0,
    engineerRenewals: 0,
  });
  const [errormodalIsOpen, setErrorModalIsOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const _clientId = localStorage.getItem("clientId");
  const disciplineID = localStorage.getItem("disciplineID");
  const moduleAccess = (localStorage.getItem("modules") || "")?.split(',')?.map(numStr => Number(numStr)).filter(num => !isNaN(num));  
  const [datashheetCalibratedPending, setDatashheetCalibratedPending] = useState(0);
  const [certificateApprovedCount, setCertificateApprovedCount] = useState(0);
  const openErrorModal = (errorMessage, stackTrace, fileName) => {
    setErrorMessage({ errorMessage, stackTrace, fileName });
    setErrorModalIsOpen(true);
  };
  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
  };

  // api calls

  const getClientCount = (event) => {
    let url = BASE_URL;
    axiosWithToken
      .get(
        url +
          `clients/count?_where=(status,ne,-1)${
            userType == 3 ? `~and(id,eq,${_clientId})` : ""
          }`
      )
      .then((res) => {
        setClientCount(res.data[0].no_of_rows);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getClientCount", "Dashboard")
              }
            >
              <u>Error: {err.message}</u>
            </h6>
          );
        }
      });
  };

  const getCertificateCount = (event) => {
    let url = BASE_URL;
    let sqlQuery ={"query": `SELECT COUNT(*) AS no_of_rows FROM certificatesView WHERE status != -1 ${userType == 3 ? `AND clientId = ${_clientId}` : ''}`}
    axiosWithToken
      .post(
        url +"dynamic",sqlQuery )
      .then((res) => {
        setCertificateCount(res.data[0].no_of_rows);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getCertificateCount", "Dashboard")
              }
            >
              <u>Error: {err.message}</u>
            </h6>
          );
        }
      });
  };

  const getCertificateNotApproved = () => {
    let query = {
      query: `SELECT count(*) as no_of_rows FROM certificatesView where status != -1 and calibratedby is NOT NULL and approvedby is NULL and discID IN (${disciplineID})`,
    };
    axiosWithToken
      .post(BASE_URL + `dynamic`, query)
      .then((res) => {
        let resCount = res.data[0].no_of_rows;
        // console.log(res.data[0].no_of_rows)
        setCertificateApprovedCount(resCount);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDatasheetCalibrated = () => {
    let query = {
      query: `select count(*) as no_of_rows from datasheets where assignedUser= ${userId} and calibratedby is null`,
    };
    axiosWithToken
      .post(BASE_URL + `dynamic`, query)
      .then((res) => {
        let resCount = res.data[0].no_of_rows;
        // console.log(res.data[0].no_of_rows)
        setDatashheetCalibratedPending(resCount);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const standardsRenewalStatus = async () => {
  //   try {
  //     const sqlQuery = {
  //       query: `UPDATE standards s JOIN (SELECT stId, serialNo, model, disciplineId, MAX(validUpto) AS latestValidUpto FROM standards WHERE status=1 GROUP BY stId, serialNo, model, disciplineId) latest ON s.stId=latest.stId AND s.serialNo=latest.serialNo AND s.model=latest.model AND s.disciplineId=latest.disciplineId SET s.renewalStatus=2 WHERE s.validUpto<latest.latestValidUpto AND s.renewalStatus<>2;`
  //     };
  //     const res = await axiosWithToken.post(BASE_URL + 'dynamic', sqlQuery);
  //     return res.data;
  //   } catch (error) {
  //     console.log("Standards renewal status update error:", error);
  //     return null;
  //   }
  // };

  // useEffect(() => {
  //   if (props.rolesInfo?.currentRole?.id == 2){
  //     const updateStdQuery = async () => {
  //       try {
  //         await standardsRenewalStatus();
  //       } catch (err) {
  //         console.error("Error updating renewal status:", err);
  //       }
  //     };  
  //     updateStdQuery();
  //   }
  // }, []);

  useEffect(() => {
    getClientCount();
    getCertificateCount();
    getCertificateNotApproved();
    getDatasheetCalibrated();
  }, []);

  /////////////////////////////DashboardData////////////////////////

  const fetchCount = async (table, dateColumn, condition) => {
    try {
      const url = `${BASE_URL}dynamic`;
      let query;
      if (table == "standards") {
        query = `SELECT * FROM ${table} WHERE DATE(${dateColumn}) ${condition} AND status = 1 AND renewalStatus = 1`;
      }
      else if (table == "certificatesView") {
        query = `SELECT * FROM ${table} WHERE DATE(${dateColumn}) ${condition} `;
      }
      else{
        query = `SELECT * FROM ${table} WHERE DATE(${dateColumn}) ${condition} AND status = 1 `;
      }
      if (userType == 3) {
        query += ` AND clientId = ${_clientId}`;
      }
      const response = await axiosWithToken.post(url, { query });
      return response.data.length;
    } catch (error) {
      console.error(error);
      return 0;
    }
  };

  const fetchCountwihtoutDate = async (table, condition) => {
    try {
      const url = `${BASE_URL}dynamic`;
      let query;
        query = `SELECT * FROM ${table} WHERE ${condition}`;
      // if (userType == 3) {
      //   query += ` AND clientId = ${_clientId}`;
      // }
      const response = await axiosWithToken.post(url, { query });
      return response.data.length;
    } catch (error) {
      console.error(error);
      return 0;
    }
  };

  const fetchDataCounts = async () => {
    const masterRenewalCount = await fetchCount(
      "standards",
      "validUpto",
      "<= CURDATE() + INTERVAL 20 DAY"
    );
    const todaysClientsCount = await fetchCount(
      "clients",
      "lastModified",
      "= CURDATE()"
    );
    const todaysSrfsCount = await fetchCount(
      "srfs",
      "lastModified",
      "= CURDATE()"
    );
    const todaysCertificatesCount = await fetchCount(
      "certificatesView",
      "lastModified",
      "= CURDATE()"
    );
    const todaysRenewalsCount = await fetchCount(
      "certificatesView",
      "nextDueDate",
      "= CURDATE()"
    );
    const overAllActiveIncCount = await fetchCount(
      "standards",
      "validUpto",
      "<= CURDATE()"
    );
    const overAllRenewalCount = await fetchCount(
      "certificatesView",
      "nextDueDate",
      "IS NOT NULL AND DATE(nextDueDate) <= CURDATE() and status != -1 and renewalStatus = 1"
    );
    const todayClientDueCount = await fetchCount(
      "certificatesView",
      "nextDueDate",
      "= CURDATE()"
    );
     const selfJobs = await fetchCountwihtoutDate(
      "datasheets",
      `createdby = ${userId}`,
    );
    const assignedJobs = await fetchCountwihtoutDate(
      "datasheets",
      `assignedUser = ${userId}`,
    );
    const pendingJobs = await fetchCountwihtoutDate(
      "datasheets",
      `(totalReadings IS NULL OR totalReadings = 0) and (createdby = ${userId} or assignedUser = ${userId})`,
    );
    const completedJobs = await fetchCountwihtoutDate(
      "datasheets",
      `(totalReadings IS NOT NULL and totalReadings > 0) and (createdby = ${userId} or assignedUser = ${userId})`,
    );
    const engineerRenewals = await fetchCountwihtoutDate(
      "certificatesView",
      `renewalStatus = 1 and (nextDueDate IS NOT NULL and nextDueDate <= CURDATE()) and (createdby = ${userId} or assignedUser = ${userId})`,
    );

    setCounts((prevCounts) => ({
      ...prevCounts,
      todaysClientsCount,
      todaysSrfsCount,
      todaysCertificatesCount,
      todaysRenewalsCount,
      overAllActiveIncCount,
      overAllRenewalCount,
      todayClientDueCount,
      masterRenewalCount,
      selfJobs,
      assignedJobs,
      pendingJobs,
      completedJobs,
      engineerRenewals
    }));
  };

   const handleRenewalStatusDynamic = () => {
      let url = BASE_URL;
      let sqlQuery = {
        query:
          "UPDATE certificates AS old JOIN certificates AS newer ON newer.clientId = old.clientId AND newer.DUCID = old.DUCID AND newer.instrumentId = old.instrumentId AND COALESCE(TRIM(newer.serialNumber), '') = COALESCE(TRIM(old.serialNumber), '') AND COALESCE(TRIM(newer.ranges), '') = COALESCE(TRIM(old.ranges), '') AND COALESCE(TRIM(newer.lc), '') = COALESCE(TRIM(old.lc), '') AND newer.nextDueDate > old.nextDueDate SET old.renewalStatus = 2 WHERE old.nextDueDate IS NOT NULL AND DATE(old.nextDueDate) <= CURDATE() AND old.status != -1 AND old.renewalStatus = 1",
      };
      axiosWithToken
        .post(url + `dynamic`, sqlQuery)
        .then((res) => {
          // window.location.reload();
        })
        .catch((err) => {
          console.log("error : ", err);
        });
    };

  useEffect(() => {
    fetchDataCounts();
  }, []);

  // useEffect(() => {
  //  if(userType != "3" &&  props.rolesInfo?.currentRole?.id == 2) handleRenewalStatusDynamic();
  // }, [userType,props.rolesInfo?.currentRole?.id == 2]);

  return (
    <EditWrap>
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {certificateApprovedCount != 0 && moduleAccess.includes(5)  &&
          props.rolesInfo?.currentRole?.id == 2 && (
            <div
              className="shadow-sm p-1 rounded position-fixed"
              style={{ right: "1rem" }}
            >
              <Link to="/certificate/count">
                <button
                  type="button"
                  className="btn btn-warning btn-md"
                  onClick={() => sessionStorage.setItem("searched", "true")}
                >
                  <b>Approval Request ({certificateApprovedCount})</b>
                </button>
              </Link>
            </div>
          )}

        {datashheetCalibratedPending != 0 && moduleAccess.includes(4) &&
          props.rolesInfo?.currentRole?.id == 1 && userType == 2 && (
            <div
              className="shadow-sm p-1 rounded position-fixed"
              style={{ right: "1rem" }}
            >
              <Link to="/datasheet/count">
                <button
                  type="button"
                  className="btn btn-warning btn-md"
                  onClick={() => sessionStorage.setItem("searched", "true")}
                >
                  <b>Job Request ({datashheetCalibratedPending})</b>
                </button>
              </Link>
            </div>
          )}

        {userType == 1 ? (
          <>
            <DucserialModal />
            <div component={Paper} sx={{ mt: 2 }}>
              <Divider sx={{ mt: 5 }}>
                <Chip
                  label="OVERALL"
                  variant="outlined"
                  sx={{ fontSize: "16px" }}
                  style={{ fontWeight: "bold" }}
                />
              </Divider>
              <Grid container spacing={2}>
                {userType != 3 && (
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <CustomCard
                      id="dashboard_clients"
                      icon={GroupIcon}
                      iconColor="#283593"
                      title="Clients"
                      count={clientCount}
                      link="/master/client"
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <CustomCard
                  id="dashboard_certificates"
                    icon={CardGiftcardOutlinedIcon}
                    iconColor="#283593"
                    title="Certificates"
                    count={certificateCount}
                    link="/certificate"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <CustomCard
                  id="dashboard_renewal"
                    icon={PrecisionManufacturingOutlinedIcon}
                    iconColor="#283593"
                    title="DUC Renewals"
                    count={counts.overAllRenewalCount}
                    link="/scheduler"
                  />
                </Grid>
                {userType != 3 && (
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <CustomCard
                    id="dashboard_Master_Renewals"
                      icon={RotateLeftOutlinedIcon}
                      iconColor="#283593"
                      title="Master Renewals"
                      count={counts.masterRenewalCount}
                      link="/master/masterEQP/count"
                    />
                  </Grid>
                )}
                {userType == 3 && (
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <CustomCard
                      icon={RotateLeftOutlinedIcon}
                      iconColor="#283593"
                      title="Dues"
                      count={counts.overAllClientDueCount}
                      link="/scheduler"
                    />
                  </Grid>
                )}
              </Grid>
            </div>
            <div component={Paper} sx={{ mt: 5 }}>
              <Divider sx={{ mt: 5 }}>
                <Chip
                  label="TODAY'S"
                  variant="outlined"
                  sx={{ fontSize: "1rem" }}
                  style={{ fontWeight: "bold" }}
                />
              </Divider>
              <Grid container spacing={2}>
                {userType != 3 && (
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <CustomCard
                    id="dashboard_todayclients"
                      icon={GroupIcon}
                      iconColor="#ff5722"
                      title="New Clients"
                      count={counts.todaysClientsCount}
                      link="/master/client/count"
                    />
                  </Grid>
                )}
                {userType != 3 && (
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <CustomCard
                    id="dashboard_SRF"
                      icon={ArticleIcon}
                      iconColor="#ff5722"
                      title="New Inward"
                      count={counts.todaysSrfsCount}
                      link="/inward/count"
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <CustomCard
                    id="dashboard_todaycertificates"
                    icon={CardGiftcardOutlinedIcon}
                    iconColor="#ff5722"
                    title="Certificates"
                    count={counts.todaysCertificatesCount}
                    link="/certificate/today"
                  />
                </Grid>
                {userType != 3 && (
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <CustomCard
                    id="dashboard_todayrenewal"
                      icon={RotateLeftOutlinedIcon}
                      iconColor="#ff5722"
                      title="DUC Renewals"
                      count={counts.todaysRenewalsCount}
                      link="/scheduler/count"
                    />
                  </Grid>
                )}
                {userType == 3 && (
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <CustomCard
                      icon={RotateLeftOutlinedIcon}
                      iconColor="#ff5722"
                      title="Dues"
                      count={counts.todayClientDueCount}
                      link="/scheduler"
                    />
                  </Grid>
                )}
              </Grid>
            </div>
            <div component={Paper} sx={{ mt: 5 }}>
              <Divider sx={{ mt: 5 }}>
                <Chip
                  label="ANALYTICS"
                  variant="outlined"
                  sx={{ fontSize: "16px" }}
                  style={{ fontWeight: "bold" }}
                />
              </Divider>
              <Tabs
                defaultActiveKey="profile"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="profile" title="Commercial Today's Report">
                  <PaymentReport />
                </Tab>
                <Tab eventKey="master" title="Overall Master Out-in">
                  <StdInOut />
                </Tab>
                <Tab eventKey="todaysMaster" title="Today Master Out-in">
                  <TodaysStdInOut />
                </Tab>
              </Tabs>
            </div>
          </>
          ) : userType == 2 ? (
           // Engineer Dashboard
            <div component={Paper} sx={{ mt: 5 }}>
              <Divider sx={{ mt: 5 }}>
                <Chip
                  label="Overall Statistics"
                  variant="outlined"
                  sx={{ fontSize: "16px" }}
                  style={{ fontWeight: "bold" }}
                />
              </Divider>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <CustomCard
                    icon={ArticleIcon}
                    iconColor="#283593"
                    title="Self Jobs"
                    count={counts.selfJobs || 0}
                    link="/datasheet?filter=self"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <CustomCard
                    icon={GroupIcon}
                    iconColor="#283593"
                    title="Assigned Jobs"
                    count={counts.assignedJobs || 0}
                    link="/datasheet?filter=assigned"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <CustomCard
                    icon={HelpIcon}
                    iconColor="#283593"
                    title="Pending Jobs"
                    count={counts.pendingJobs || 0}
                    link="/datasheet?filter=pending"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <CustomCard
                    icon={CardGiftcardOutlinedIcon}
                    iconColor="#283593"
                    title="Completed Jobs"
                    count={counts.completedJobs || 0}
                    link="/datasheet?filter=completed"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <CustomCard
                    icon={RotateLeftOutlinedIcon}
                    iconColor="#283593"
                    title="DUC Renewal"
                    count={counts.engineerRenewals || 0}
                    link="/scheduler?filter=engineerRenewals"
                  />
                </Grid>
                 <Grid item xs={12} sm={6} md={4} lg={3}>
                    <CustomCard
                    id="dashboard_Master_Renewals"
                      icon={RotateLeftOutlinedIcon}
                      iconColor="#283593"
                      title="Master Renewals"
                      count={counts.masterRenewalCount}
                      link="/master/masterEQP/count"
                    />
                  </Grid>
              </Grid>
            </div>
          ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              style={{
                height: "auto",
                maxHeight: "100%",
                maxWidth: "100%",
                width: "95%",
                objectFit: "contain",
              }}
              src={Dashboard_background}
              alt="dashboard_background"
            />
          </div>
        )}

        {errormodalIsOpen && (
          <ErrorModal
            errormodalIsOpen={errormodalIsOpen}
            closeErrorModal={closeErrorModal}
            errorMessage={errorMessage}
          />
        )}
      </div>
    </EditWrap>
  );
}
